module.exports = __webpack_public_path__ + "img/landing_box50.c22fe792.jpg";